import React from 'react';

import { EnvironmentProvider } from '../../contexts/EnvironmentContext';

import PrivacyPageComponent from './components/PrivacyPageComponent';

type TPrivacyAppProps = {
  environment: any;
};

const PrivacyApp = ({ environment }: TPrivacyAppProps) => (
  <EnvironmentProvider value={environment}>
    <PrivacyPageComponent />
  </EnvironmentProvider>
);

export default PrivacyApp;
